module.exports = __webpack_public_path__ + "fonts/317b418.ttf";